/* eslint-disable @typescript-eslint/no-use-before-define */
import { ConsultationSessionState } from '@nimbus-library/features/shared/models/participant-info/i-combined-conversation.response';
import { TransferRequestType } from '../enums/transfer-request-type';
import { TransferType } from '../enums/transfer-type';
import { Modality } from './task-types.model';
import { CallerIdentifier } from './task-attributes.model';
import { UserConversationState, UserSessionState } from './user-session';

export class CallTransfer {
  public userSessionState: UserSessionState;
  public userConversationState: UserConversationState;
  public consultationSessionState?: ConsultationSessionState;

  public constructor(
    public unifiedConversationId: string, // Represents the entire customer journey/call across all services
    public conversationId: string, // (ServiceSessionId) Represents the specific conversation within the customer journey
    public modality: Modality,
    public type: TransferType,
    public serviceId: string,
    public serviceName?: string,
    public callerName?: string,
    public isPstnService?: boolean,
    public target?: string,
    public transferTargetName?: string,
    public state: TransferState = TransferState.Initial,
    public errorMessage?: string,
  ) {}
}

export enum TransferState {
  Initial = 'Initial',
  Transferring = 'Transferring',
  TransferSuccessful = 'TransferSuccessful',
  TransferFailed = 'TransferFailed',
  InConsultativeTransfer = 'InConsultativeTransfer',
}

export class CallTransferRequest {
  public constructor(
    public target: CallerIdentifier,
    public endpointType: TransferRequestType = TransferRequestType.Default,
    public serviceName: string = null,
    public callerName: string = null,
    public consultationType: ConsultationType = ConsultationType.User,
  ) {}
}

export interface ConsultationCallToServiceRequest {
  targetTeamId: string;
  sourceServiceName: string;
}

export enum ConsultationType {
  User = 'User',
  Service = 'Service',
  External = 'External',
}
